<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/weier/sample/update/log/page" ref="yt" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yangbenleixing')">
            <yi_dictionary_select :max="1" :type="'QUALITY_SAMPLE_INFO_TYPE'" :ids.sync="yt.conditions.sampleType"> </yi_dictionary_select>
          </el-form-item>

          <el-button @click="yt.get(1)" type="primary" plain size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="yt.clear()" size="mini">{{ $t('chongzhi') }}</el-button>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_customize_weier_sample_update_log_list',
  data() {
    return {
      columns: [
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'yangbenleixing',
          type: 'dictionary',
          key: 'QUALITY_SAMPLE_INFO_TYPE',
          prop: 'weierSampleInformationVO.sampleType'
        },
        {
          label: 'kaishishengxiaoshijian-xiugaiqian',
          type: 'time',
          prop: 'beforeStartDate'
        },
        {
          label: 'kaishishengxiaoshijian-xiugaihou',
          type: 'time',
          prop: 'currentStartDate'
        },
        {
          label: 'jieshushengxiaoshijian-xiugaiqian',
          prop: 'beforeEndDate',
          type: 'time'
        },

        {
          label: 'jieshushengxiaoshijian-xiugaihou',
          prop: 'currentEndDate',
          type: 'time'
        },
        {
          label: 'beizhu-xiugaiqian',
          prop: 'beforeRemark'
        },
        {
          label: 'beizhu-xiugaihou',
          prop: 'currentRemark'
        },
        {
          label: 'xiugairen',
          prop: 'createByObject.nickname'
        },
        {
          label: 'xiugaishijian',
          prop: 'createTime',
          type: 'time'
        }
      ]
    };
  },
  created() {
    console.log('created');
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  }
};
</script>
